<template>
    <div class="yhlb" v-loading.fullscreen.lock="loading">
        <div class="my-table">
            <div class="top">
                <div class="option">
                    查询单位用户：
                    <el-select v-model="name"
                               filterable
                               placeholder="请选择"
                               @change="getUserList"
                               clearable>
                        <el-option v-for="item in divList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.name">
                        </el-option>
                    </el-select>
                    <el-button v-show="show" size="small" @click="showAll">显示全部</el-button>
                    <el-button size="small" @click="del">批量删除</el-button>
                    <el-checkbox v-model="import" @change="editPermission('import',$event)" label="修改导入权限" border></el-checkbox>
                    <el-checkbox v-model="lastImport" @change="editPermission('lastImport',$event)" label="修改去年导入权限" border></el-checkbox>
                    <el-checkbox v-model="download" @change="editPermission('download',$event)" label="修改下载权限" border></el-checkbox>
                    <el-checkbox v-model="editLast" @change="editPermission('editLast',$event)" label="是否修改去年数" border></el-checkbox>
                    <el-checkbox v-model="copyDepartment" @change="editPermission('copyDepartment',$event)" label="是否复制部门数据" border></el-checkbox>
                </div>
            </div>
        </div>
        <el-table :data="tableData" stripe border :header-cell-style="headerCellStyle" :height="tableHeight" @selection-change="multipleselect">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="所属单位" prop="divName"> </el-table-column>
            <el-table-column label="用户">
                <template #default="scope">
                    <span v-if="!detailType">{{scope.row.loginId}}</span>
                    <span v-else style="cursor: pointer; color: #409EFF" @click="showDetail(scope.row.loginId)">{{scope.row.loginId}}</span>
                </template>
            </el-table-column>
            <el-table-column label="用户类型"
                             prop="roles[0].name"
                             :filters="userType.map((e, idx)=>{return { text: e, value: idx };})" :filter-method="filterTag">
            </el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <el-popconfirm title="确定重置吗？"
                                   confirmButtonText="确定"
                                   cancelButtonText="取消"
                                   @confirm="reset(scope.row)">
                        <template #reference>
                            <el-button type="text" size="small" v-show="resetType">重置密码</el-button>
                        </template>
                    </el-popconfirm>
                    <el-popconfirm title="确定删除吗？"
                                   confirmButtonText="确定"
                                   cancelButtonText="取消"
                                   @confirm="del(scope.row)">
                        <template #reference>
                            <el-button type="text" size="small">删除</el-button>
                        </template>
                    </el-popconfirm>
                </template>
            </el-table-column>
            <el-table-column label="导入公开表">
                <template #default="scope">
                    <el-switch @change="editPermission('import',$event,scope.row)"
                               v-model="scope.row.import" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="导入去年公开表">
                <template #default="scope">
                    <el-switch @change="editPermission('lastImport',$event,scope.row)"
                               v-model="scope.row.lastImport" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="下载公开表">
                <template #default="scope">
                    <el-switch @change="editPermission('download',$event,scope.row)"
                               v-model="scope.row.download" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="修改去年数">
                <template #default="scope">
                    <el-switch @change="editPermission('editLast',$event,scope.row)"
                               v-model="scope.row.editLast" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="是否复制部门数据">
                <template #default="scope">
                    <el-switch @change="editPermission('copyDepartment',$event,scope.row)"
                               v-model="scope.row.copyDepartment" active-color="#13ce66" inactive-color="#ff4949" :disabled="scope.row.roles[0].type==0">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="个人信息" v-model="dialogTableVisible" width='70%'>
            <el-table :data="grData">
                <el-table-column prop="loginId" label="用户"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="qq" label="QQ"></el-table-column>
                <el-table-column prop="phone" label="联系电话"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import { permission, userDelete, getUsers, peruser, user, resetPassword } from "@/api/user.js";
    import { getDivs } from '@/api/div.js';
    export default {
        name: "yhlb",
        data() {
            return {
                tableHeight: document.documentElement.clientHeight - 165,
                loading: true,
                tableData: [],
                oldData: [],
                show: false,
                divList: [], //单位列表
                allList: [],
                name: "",
                value: 0,
                userType: ["单位", "科室", "部门", "管理员"],
                importList: [],
                downloadList: [],
                multipledels: [],
                detailType: false,
                dialogTableVisible: false,
                resetType: false,
                grData: [],
                import: false,
                download: false,
                lastImport: false,
                editLast: false,
                copyDepartment:false
            };
        },
        created() {
            this.getDivsList();
            if (localStorage.getItem('name') == 'dev' || localStorage.getItem('name') == '管理员') {
                this.detailType = true
            }
            if (localStorage.getItem('resetType')) {
                this.resetType = true
            }
        },
        methods: {
            reset(row) {
                this.loading = true
                resetPassword({
                    id: row.loginId
                }).then(res => {
                    if (res.status == 0) {
                        this.$message.success('密码重置成功!新密码为:' + res.password)
                    }
                    this.loading = false
                }).catch(err => {
                    this.loading = false
                })

            },
            showDetail(loginId) {
                user({ id: loginId }).then(res => {
                    if (res.status == 0) {
                        this.grData = []
                        let obj = {
                            name: res.name,
                            loginId: res.id,
                            qq: res.qq,
                            phone: res.phone,
                            email: res.email
                        }
                        this.grData.push(obj)
                        this.dialogTableVisible = true
                    }
                })
            },
            filterTag(value, row) {
                return row.roles[0].type == value;
            },
            async getUserList() {
                //获取单位用户
                if (this.name.length !== 0) {
                    this.tableData = this.oldData.filter(e => e.divName == this.name)
                    this.show = true;
                } else {
                    this.tableData = this.oldData
                    this.show = false;
                }
            },
            async getDivsList() {
                this.loading = true
                let importData = await peruser({ id: "9b76f5a7dd08479592b839f22a6427d4", });
                let lastImportData = await peruser({ id: "4b9824d94c6542dbadfe68e261bdada0", });
                let downloadData = await peruser({ id: "e846d759c1234bfdb9cbcf0bcfcefba3", });
                let editLastData = await peruser({ id: "c926ed4cfcd446a38079cc71e5405cd3", });
                let copyDepartmentData = await peruser({ id: "ee122e343e404032a9ae5768c0eb5a9e", });
                //获取类型
                getDivs().then((getdiv) => {
                    this.divList = getdiv.divs.filter((e) => e.type !== 1);
                    this.allList = getdiv.divs;
                    //获取列表
                    getUsers({ zoneid: this.$cookies.get("zone") }).then((getuser) => {
                        this.tableData = getuser.users;
                        this.tableData.forEach((e) => {
                            //获取所属单位
                            if (e.divids.length !== 0) {
                                let divname = "";
                                e.divids.forEach((id) => {
                                    let b = this.allList.find((item) => {
                                        if (item.id == id) {
                                            return item;
                                        }
                                    });
                                    if (b) {
                                        divname += b.name + ",";
                                    }
                                });
                                divname = divname.slice(0, divname.length - 1);
                                e.divName = divname;
                            }
                            e.import = importData.users.find((i) => i == e.loginId) ? true : false
                            e.lastImport = lastImportData.users.find((i) => i == e.loginId) ? true : false
                            e.download = downloadData.users.find((i) => i == e.loginId) ? true : false
                            e.editLast = editLastData.users.find((i) => i == e.loginId) ? true : false
                            e.copyDepartment = copyDepartmentData.users.find((i) => i == e.loginId) ? true : false
                            switch (e.roles[0].name) {
                                case "单位":
                                    e.roles[0].type = 0;
                                    break;
                                case "科室":
                                    e.roles[0].type = 1;
                                    break;
                                case "部门":
                                    e.roles[0].type = 2;
                                    break;
                                case "管理员":
                                    e.roles[0].type = 3;
                                    break;
                            }
                        });
                        this.isSelectAll()
                        this.oldData = this.tableData
                        this.loading = false;
                    });
                }).catch(err => {
                    this.loading = false;
                })
            },
            isSelectAll() {
                let num = this.tableData.filter((e) => e.import == false).length;
                this.import = num == 0 ? true : false;
                num = this.tableData.filter((e) => e.lastImport == false).length;
                this.lastImport = num == 0 ? true : false;
                num = this.tableData.filter((e) => e.download == false).length;
                this.download = num == 0 ? true : false;
                num = this.tableData.filter((e) => e.editLast == false).length;
                this.editLast = num == 0 ? true : false;
                num = this.tableData.filter((e) => e.copyDepartment == false).length;
                this.copyDepartment = num == 0 ? true : false;
            },
            async editPermission(type, val, row) {
                let body = {}
                if (row) {
                    body = {
                        ids: [row.loginId],
                        permissionId: powerList(type),
                        access: row[type] ? 1 : 0,
                    };
                } else {
                    if (this.multipledels.length == 0) {
                        this.$message.error("请选择单位")
                        return;
                    }
                    let ids = [];
                    this.multipledels.forEach((e) => {
                        e[type] = val == true ? true : false;
                        ids.push(e.loginId);
                    });
                    body = {
                        ids: ids,
                        permissionId: powerList(type),
                        access: val ? 1 : 0,
                    };
                }
                this.loading = true;
                let res = await permission(body);
                if (res.status == 0) {
                    this.$message.success("修改成功");
                    this.isSelectAll()
                }
                this.loading = false;
                function powerList(name) {
                    var str = ""
                    switch (name) {
                        case "import":
                            str = "9b76f5a7dd08479592b839f22a6427d4"
                            break;
                        case "lastImport":
                            str = "4b9824d94c6542dbadfe68e261bdada0"
                            break;
                        case "download":
                            str = "e846d759c1234bfdb9cbcf0bcfcefba3"
                            break;
                        case "editLast":
                            str = "c926ed4cfcd446a38079cc71e5405cd3"
                            break;
                        case "copyDepartment":
                            str = "ee122e343e404032a9ae5768c0eb5a9e"
                            break;
                        default:
                            str = ""
                    }
                    return str
                }
            },
            showAll() {
                this.show = false;
                this.tableData = this.oldData;
                this.name = "";
            },
            async del(row) {
                let arr = []
                this.loading = true;
                if (row) {
                    this.multipledels.push(row)
                } else {
                    if (this.multipledels.length == 0) {
                        this.$message.error("请选择单位")
                        return;
                    }
                }
                for (let index = 0; index < this.multipledels.length; index++) {
                    const element = this.multipledels[index];
                    let res = await userDelete({ id: element.loginId })
                    if (res.status == 0) {
                        this.tableData = this.tableData.filter((ele) => ele.loginId !== element.loginId);
                    } else {
                        arr.push(index)
                    }
                }
                if (arr.length == 0) {
                    this.$message.success("删除成功")
                } else {
                    this.$message.error("删除失败")
                }
                this.loading = false;
            },
            //获取选择行的信息
            multipleselect(list) {
                this.multipledels = list;
            },
            headerCellStyle() {
                return { background: "#E5F2FF" };
            },
        },
    };
</script>

<style scoped>
    .yhlb {
        width: 95%;
        margin: 0 auto;
    }

    .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .el-button--small {
        min-height: 40px;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 3px;
    }

    .option {
        display: flex;
        align-items: center;
        margin: 30px 0 10px 0px;
    }

    .el-checkbox, .el-button, .el-select {
        margin: 0px 10px !important
    }
</style>